import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Dispatch from '../core/Dispatch';
import { PROGRAMMATIC_SCROLL_START, PROGRAMMATIC_SCROLL_END } from './events';
import { isTouch } from './helpers';

gsap.registerPlugin(ScrollToPlugin);

/**
 * @param y
 * @param vars
 * @param offsetY
 * @returns {gsap.core.Tween}
 */
export default (y, vars = {}, offsetY = 0) => {
    let scrollMarginTop = 0;
    if (y instanceof HTMLElement) {
        scrollMarginTop = parseInt((window.getComputedStyle(y).scrollMarginTop || '0').replace('px', ''), 10) || 0;
    }
    let onComplete;
    if (vars.hasOwnProperty('onComplete')) {
        onComplete = vars.onComplete;
        delete vars.onComplete;
    }
    const tweenVars = {
        scrollTo: {
            y,
            offsetY: Math.max(0, offsetY + scrollMarginTop),
            autoKill: !isTouch(),
            onAutoKill() {
                Dispatch.emit(PROGRAMMATIC_SCROLL_END);
            }
        },
        duration: 1,
        ease: 'Power2.easeInOut',
        onStart() {
            Dispatch.emit(PROGRAMMATIC_SCROLL_START);
        },
        onComplete() {
            Dispatch.emit(PROGRAMMATIC_SCROLL_END);
            if (y instanceof HTMLElement && (y.tagName === 'A' || y.tagName === 'BUTTON')) {
                try {
                    y.focus();
                } catch (error) {
                    // Dont care
                }
            }
            if (onComplete) {
                onComplete();
            }
        },
        ...vars
    };
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)');
    if (reduceMotionQuery.matches) {
        tweenVars.duration = 0.001;
    }
    return gsap.to(window, tweenVars);
};
